import { BACKEND_URL_V1, get, post } from "lib/Api";
import {
  ICateringEventView,
  ICateringEventDetailedView,
  ICreateCateringEventRequest,
  IUpdateCateringEventRequest,
  IConfigureCateringEventMenuRequest,
  IOverrideMaterialsRequest,
  ICateringConsolidationStep1Request,
  ICateringConsolidationStep1Response,
  ICateringConsolidationStep2Request,
  ICateringConsolidationConfirmationResponse,
  IProcessConsolidationResponse,
} from "types/CateringEvent";

const BASE = `${BACKEND_URL_V1}/catering/events`;

export const listCateringEvents = async (
  start: string,
  end: string
): Promise<{ cateringEvents: ICateringEventView[] } | null> => {
  try {
    const response = await get<{ cateringEvents: ICateringEventView[] }>(
      `${BASE}/?start=${start}&end=${end}`
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const getCateringEvent = async (
  id: string
): Promise<{ cateringEvent: ICateringEventView } | null> => {
  try {
    const response = await get<{ cateringEvent: ICateringEventView }>(
      `${BASE}/${id}`
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const createCateringEvent = async (
  request: ICreateCateringEventRequest
): Promise<{ cateringEvent: ICateringEventView } | null> => {
  try {
    const response = await post<{ cateringEvent: ICateringEventView }>(
      `${BASE}/`,
      request
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const updateCateringEvent = async (
  id: string,
  request: IUpdateCateringEventRequest
): Promise<{ cateringEvent: ICateringEventView } | null> => {
  try {
    const response = await post<{ cateringEvent: ICateringEventView }>(
      `${BASE}/${id}`,
      request
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const configureEventMenu = async (
  id: string,
  request: IConfigureCateringEventMenuRequest
): Promise<ICateringEventDetailedView | null> => {
  try {
    const response = await post<ICateringEventDetailedView>(
      `${BASE}/${id}/menu`,
      request
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const getEventMenuDetails = async (
  id: string
): Promise<ICateringEventDetailedView | null> => {
  try {
    const response = await get<ICateringEventDetailedView>(
      `${BASE}/${id}/menuDetails`
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const overrideMaterials = async (
  id: string,
  request: IOverrideMaterialsRequest
): Promise<ICateringEventDetailedView | null> => {
  try {
    const response = await post<ICateringEventDetailedView>(
      `${BASE}/${id}/overrideMaterials`,
      request
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const getSupplierOptions = async (
  request: ICateringConsolidationStep1Request
): Promise<ICateringConsolidationStep1Response | null> => {
  try {
    const response = await post<ICateringConsolidationStep1Response>(
      `${BASE}/consolidate/supplierOptions`,
      request
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const confirmConsolidation = async (
  request: ICateringConsolidationStep2Request
): Promise<ICateringConsolidationConfirmationResponse | null> => {
  try {
    const response = await post<ICateringConsolidationConfirmationResponse>(
      `${BASE}/consolidate/confirm`,
      request
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const processConsolidation = async (
  request: ICateringConsolidationStep2Request
): Promise<IProcessConsolidationResponse | null> => {
  try {
    const response = await post<IProcessConsolidationResponse>(
      `${BASE}/consolidate/process`,
      request
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

